import React, { FC } from 'react';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment, WidgetProps } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import { useSettingsParams } from '../../../hooks';
import { noModal, ModalType, GenericModal } from '../../../types/common';
import { MainViewDisplayType } from '../../PackagePicker/settingsParams';
import { AlertModal } from '../../PackagePicker/Widget/AlertModal';
import List, { ListWidgetProps } from '../../PackagePicker/Widget/List';
import { EmptyStateProps } from '../../PackagePicker/Widget/List/EmptyState';
import { PlanListWidgetContext } from './PlanListWidgetContext';

const LazyTabsView = loadable(() => import('../../PackagePicker/Widget/TabsView'));

export interface ListWidgetWithModalProps extends ListWidgetProps {
  modal: GenericModal<ModalType.PurchaseInPreview> | typeof noModal;
}

const Widget: FC<WidgetProps<ListWidgetWithModalProps>> = (props) => {
  const { isMobile } = useEnvironment();
  const emptyState: EmptyStateProps = { isInWidget: true };
  const width = props.host.dimensions.width ?? (isMobile ? 320 : 980);

  return (
    <PlanListWidgetContext locale={props.locale} width={width}>
      <View {...props} emptyState={emptyState} />
      {props.modal.type === ModalType.PurchaseInPreview && <AlertModal {...props.modal} />}
    </PlanListWidgetContext>
  );
};

const View: FC<WidgetProps<ListWidgetWithModalProps> & { emptyState: EmptyStateProps }> = (props) => {
  const settings = useSettings();
  const settingsParams = useSettingsParams();

  const displayType = settings.get(settingsParams.mainViewDisplayType);

  if (props.isTabsViewEnabled && displayType === MainViewDisplayType.TABS) {
    return <LazyTabsView {...props} dataHook={VIEWER_HOOKS.PLAN_LIST_WRAPPER} />;
  }

  return <List {...props} dataHook={VIEWER_HOOKS.PLAN_LIST_WRAPPER} />;
};

export default Widget;
